import {Directive, ElementRef, Host, HostListener} from '@angular/core';
import {EkranDecyzjiComponent} from '../../samoobsluga/proces-decyzji/ekran-decyzji/ekran-decyzji.component';

@Directive({
  selector: '[appIban]',
})
export class IbanDirective {

  constructor(private el: ElementRef,
              @Host() private ekranDecyzjiComponent: EkranDecyzjiComponent) {
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    this.ekranDecyzjiComponent.zmienKomunikat(true);
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    this.ekranDecyzjiComponent.zmienKomunikat(false);
  }
}
